module.exports = __webpack_public_path__ + "static/media/lemon-pdf.c9fa00e2.svg";